import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BaseIconComponent } from '../base-icon.component'

@Component({
  selector: 'app-icon-no-users',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.334 7.66699L27.334 3.66699"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.334 7.66699L23.334 3.66699"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5 29V27C20.5 25.9391 20.0786 24.9217 19.3284 24.1716C18.5783 23.4214 17.5609 23 16.5 23H8.5C7.43913 23 6.42172 23.4214 5.67157 24.1716C4.92143 24.9217 4.5 25.9391 4.5 27V29"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 19C14.7091 19 16.5 17.2091 16.5 15C16.5 12.7909 14.7091 11 12.5 11C10.2909 11 8.5 12.7909 8.5 15C8.5 17.2091 10.2909 19 12.5 19Z"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoUsersIconComponent extends BaseIconComponent {}
